function normalizePlainTextLineBreaks(text) {
  return String(text).replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/\n/g, '<br>');
}

function looksLikeIntroductionHtml(value) {
  return /<[a-z][\w-]*(\s|>)/i.test(value);
}

function processIntroductionHtmlTextNodes(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  let current = walker.nextNode();
  while (current) {
    textNodes.push(current);
    current = walker.nextNode();
  }

  textNodes.forEach((textNode) => {
    const raw = textNode.textContent;
    if (!raw.trim()) {
      textNode.textContent = '';
      return;
    }

    const normalized = raw.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    if (!normalized.includes('\n')) {
      textNode.textContent = normalized;
      return;
    }

    const parts = normalized.split('\n');
    const fragment = document.createDocumentFragment();
    parts.forEach((part, index) => {
      if (part) {
        fragment.appendChild(document.createTextNode(part));
      }
      if (index < parts.length - 1) {
        fragment.appendChild(document.createElement('br'));
      }
    });
    textNode.replaceWith(fragment);
  });
}

function formatHtmlIntroductionMessage(html) {
  if (typeof document === 'undefined') {
    return String(html).replace(/>\s*[\r\n]+\s*</g, '><');
  }

  const doc = new DOMParser().parseFromString(String(html), 'text/html');
  processIntroductionHtmlTextNodes(doc.body);
  return doc.body.innerHTML;
}

/**
 * Normalize introduction message line breaks for HTML display.
 * Plain-text API values may use CRLF/LF; HTML collapses those unless converted to <br>.
 * Rich HTML only converts newlines inside text content, not whitespace between tags.
 */
export function formatIntroductionMessageForDisplay(message = '') {
  const text = String(message ?? '');
  if (!text.trim()) {
    return '';
  }

  if (looksLikeIntroductionHtml(text)) {
    return formatHtmlIntroductionMessage(text);
  }

  return normalizePlainTextLineBreaks(text);
}
